import axios from 'axios'
import { Message } from 'element-ui'
const _axios = axios.create({
    baseURL: process.env.VUE_APP_BASEURL,
})

// 请求拦截器配置
// _axios.interceptors.request.use(config => {
// })

// 响应拦截器配置
_axios.interceptors.response.use(response => {
    if (response.data.status !== 0) {
        Message.error(response.data.desc)
    }
    return response;
}, error => {
    Message.error("系统异常,请联系管理员")
    console.log(error);
})


export default _axios